export default "__VITE_ASSET__Cxs_9N24__"